<template>
  <div class="date-container">
    <div class="agenda-date-tabs flex">
      <div
        class="agenda-date-tab flex cs"
        :class="{ active: dateIndex === activeDateIndex }"
        v-for="(agenda, dateIndex) in dateList"
        :key="dateIndex"
        @click="didClick_Date(dateIndex)"
      >
        <span class="day flex align-center">{{ agenda.day }}</span>
        <span class="month flex align-center"
          >{{ agenda.month }}月<br />{{ agenda.year }}</span
        >
      </div>
      <div class="whiteline"></div>
    </div>
    <unSignUp
      :tips="tips"
      :btn="btnText"
      ref="agenda_Diaolog"
      @didClickunSignUp="didClickunSignUp"
    ></unSignUp>
  </div>
</template>

<script>
export default {
  name: "dateTab",
  props: {
    dateList: {
      type: Array,
      default() {
        return [];
      },
    },
    dateIndex: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  data() {
    return {
      activeDateIndex: 0,
      btnText: "好的",
      tips: "更多内容，敬请期待",
    };
  },
  components: {
    unSignUp: () => import("../dialog/type/UnSignUp.vue"),
  },
  mounted() {
    this.activeDateIndex = this.dateIndex;
  },
  methods: {
    didClick_Date(idx) {
      // if (idx == 1) {
      //   this.$refs.agenda_Diaolog.showDialog();
      //   setTimeout(() => {
      //     this.$refs.agenda_Diaolog.hideDialog();
      //   }, 3000);
      // }
      this.activeDateIndex = idx;
      this.$emit("dateChange", idx);
    },
    didClickunSignUp() {
      this.$refs.agenda_Diaolog.hideDialog();
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 992px) {
  .date-container {
    width: 100%;
    position: relative;
    .agenda-date-tabs {
      //border-bottom: 2px solid rgba(221, 221, 221, 0.2);
      height: auto;
      .agenda-date-tab {
        width: auto;
        padding-right: 30px;
        color: #999999;
        height: 80px;
        border-bottom: 4px solid transparent;
        &:not(:first-child) {
          margin-left: 48px;
        }
        .day {
          height: 100%;
          font-size: 38px;
          font-family: Microsoft YaHei-Light;
          font-weight: 900;
        }
        .month {
          margin-left: 10px;
          padding-left: 20px;
          height: 100%;
          font-size: 15px;
          font-family: Microsoft YaHei-Light;
          background: url("../../assets/images/parallelSessions/date-line-pc.png");
          background-repeat: no-repeat;
          background-position: center left;
        }
        &.active {
          color: #b4251e;
          border-bottom: 4px solid #b4251e;
        }
      }
    }
    .whiteline {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 4px;
      background: #ffffff;
      border-radius: 0px 0px 0px 0px;
      opacity: 0.3;
    }
  }
}
@media screen and (max-width: 992px) {
  .date-container {
    width: calc(100vw - 70px);
    .agenda-date-tabs {
      margin-top: 38px;
      padding-bottom: 20px;
      .agenda-date-tab {
        color: #999999;
        height: 48px;
        padding-left: 12px;
        height: auto;
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        border-left: 5px solid transparent;

        &:not(:first-child) {
          margin-left: 48px;
        }
        .day {
          height: 100%;
          font-size: 52px;
          font-family: Microsoft YaHei-Bold, Microsoft YaHei;
          font-weight: 900;
          align-items: flex-end;
          line-height: 1;
        }
        .month {
          margin-left: 5px;
          padding-left: 30px;
          height: 100%;
          font-size: 20px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          background: url("../../assets/images/parallelSessions/date-line-wap.png");
          background-size: 20px 60px;
          background-repeat: no-repeat;
          background-position: bottom left;
          align-items: flex-end;
          line-height: 1.2;
        }
        &.active {
          color: #b4251e;
          border-left: 6px solid #b4251e;
          .month {
            color: #b4251e;
          }
        }
      }
    }
  }
}
</style>
